export default __webpack_public_path__ + "static/media/gallery-wip-blade plug_04.8f934d23.jpg";